export default __webpack_public_path__ + "static/media/NAAC.cc4ff2a5.png";